export default (function (_ref) {
  var id = _ref.id,
    el = _ref.el,
    payload = _ref.payload,
    isCookieDebug = _ref.isCookieDebug;
  if (process.env.disableTrackEvent === 'true') {
    console.warn('track event module is disabled by DISABLED_TRACK_EVENT env var');
    return;
  }
  var data = payload.data,
    fn = payload.fn;
  var eventType = fn !== null && fn !== void 0 ? fn : 'track-event';
  if (process.client && !!isCookieDebug) console.info('generic-tracking ', {
    id: id,
    el: el,
    data: data
  });
  if (window && window.mdm_events) window.mdm_events(id, el, eventType, data);
});